import {Media} from "@/smilebook-shared/types";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {DIVIDER, PD_LG, PD_SM} from "@/shared/dimens";
import {Button, Typography, useTheme} from "@mui/material";
import {DeleteOutlineOutlined} from "@mui/icons-material";

export function MediaView(props: {
  media: Media,
  selectedImage: string,
  setSelectedImage: (id: string) => void
}): ReactElement {
  const theme = useTheme();
  return <>
    <StyledBoxColumn style={{gap: PD_LG, overflowY: "scroll"}}>
      {props.media.images.map(image => <StyledBoxColumn style={{gap: 0}}>
        <Button
          onClick={() => props.setSelectedImage(image.id)}
          style={{
            gap: PD_SM,
            aspectRatio: 1,
            padding: 0,
            border: props.selectedImage === image.id ? "2px solid " + theme.palette.primary.main : DIVIDER,
          }}>
          <img src={image.url} style={{width: "100%", height: "100%", objectFit: "cover"}}/>
        </Button>
        <StyledBoxRow style={{
          alignItems: "center",
          height: 72,
          left: 0,
          right: 0,
          bottom: 0,
          padding: PD_SM,
        }}>
          <Typography variant={"body2"} style={{
            width: 240,
            //@ts-ignore
            textWrap: "nowrap",
            textOverflow: "ellipsis",
            fontWeight: "bold"
          }}>{image.name}</Typography>
          <StyledSpan/>
          {props.selectedImage === image.id
            ? <>
              <Button color={"error"} variant={"contained"}>
                <DeleteOutlineOutlined/>
              </Button>
            </>
            : null}
        </StyledBoxRow>
      </StyledBoxColumn>)}
    </StyledBoxColumn>
  </>;
}